// Google Tag Manager dataLayer event emission.
// Silent no-op when window.dataLayer is not defined.

type DataLayerPayload = Record<string, unknown>;

interface DataLayerGlobal {
  dataLayer?: Array<{ event: string } & DataLayerPayload>;
}

export function emit(event: string, payload: DataLayerPayload = {}): void {
  const g = window as unknown as DataLayerGlobal;
  if (!Array.isArray(g.dataLayer)) return;
  g.dataLayer.push({ event, ...payload });
}
